export function Placeholder({ title, milestone }: { title: string; milestone?: number }) {
  return (
    <section className="page">
      <header className="page-h">
        <h1>{title}</h1>
      </header>
      <p className="muted">{milestone ? `Arrives in milestone ${milestone}.` : 'Nothing here.'}</p>
    </section>
  )
}
